const ServiceOverview = () => {
  const features = [
    {
      icon: 'ri-building-line',
      title: 'Foundation & Slab Pours',
      description: 'Expert concrete delivery for residential and commercial foundations, ensuring structural integrity.',
    },
    {
      icon: 'ri-home-4-line',
      title: 'Residential & Commercial',
      description: 'Serving both homeowners and contractors with reliable pumping services for any project scale.',
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Pool Deck Installations',
      description: 'Precision pouring for pool decks, patios, and surrounding areas with smooth finishes.',
    },
    {
      icon: 'ri-road-map-line',
      title: 'Driveways & Parking Lots',
      description: 'Efficient concrete placement for driveways, parking areas, and access roads.',
    },
    {
      icon: 'ri-skyscraper-line',
      title: 'High-Rise Delivery',
      description: 'Advanced pumping equipment capable of reaching elevated construction sites safely.',
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Tight Space Precision',
      description: 'Specialized equipment and techniques for hard-to-reach areas and confined spaces.',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-6">
            Why Choose Our Concrete Pumping?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We deliver concrete efficiently and precisely using state-of-the-art pumping equipment. 
            Our experienced team ensures your project stays on schedule with professional service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all"
            >
              <div className="w-16 h-16 bg-yellow-500 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-4xl text-black`}></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">{feature.title}</h3>
              <p className="text-gray-700 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOverview;